import { SORT_ORDER, DEFAULT_SORT_ORDER, PAGE_SIZE } from '@/shared/constants';
import { generateGetters } from '@/shared/helpers';

import service from './service';

const DEFAULT_SORT_BY = 'id';

const state = {
  attributes: [],
  pageInfo: {
    totalItems: 0,
    totalPages: 0,
    pageNumber: 1,
  },
  sortBy: DEFAULT_SORT_BY,
  sortOrder: DEFAULT_SORT_ORDER,
  searchQuery: null,
  selectedItemId: null,
};

const getters = {
  ...generateGetters([
    'attributesList',
    'attribute',
    'pageInfo',
    'sortBy',
    'sortOrder',
    'searchQuery',
    'selectedItemId',
  ]),
};

const actions = {
  async getAll(
    { commit, state },
    {
      pageNumber = state.pageInfo.pageNumber,
      sortBy = state.sortBy,
      sortOrder = state.sortOrder,
      searchQuery = state.searchQuery,
    }
  ) {
    const results = await service.getByParams(
      pageNumber,
      PAGE_SIZE,
      sortBy,
      sortOrder,
      searchQuery
    );
    commit('setAttributesList', results);
  },
  async getById({ commit }, id){
    const data = service.getById(id);
    commit('setAttribute', data);
  },
  async sortGrid({ commit, state }, sortBy, sortOrder = null) {
    if (sortBy == state.sortBy && sortOrder == state.sortOrder) {
      return;
    }
    if (!sortOrder) {
      sortOrder =
        state.sortOrder == SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC;
    }
    if (sortBy != state.sortBy) {
      sortOrder = DEFAULT_SORT_ORDER;
    }
    const results = await service.getByParams(
      1,
      PAGE_SIZE,
      sortBy,
      sortOrder,
      state.searchQuery
    );
    commit('setAttributesList', { ...results, sortBy, sortOrder });
  },
  async getPage({ commit, state }, pageNumber) {
    if (pageNumber == state.pageInfo.pageNumber) {
      return;
    }
    const results = await service.getByParams(
      pageNumber,
      PAGE_SIZE,
      state.sortBy,
      state.sortOrder,
      state.searchQuery
    );
    commit('setAttributesList', results);
  },
  async search({ commit, state }, searchQuery) {
    const results = await service.getByParams(
      1,
      PAGE_SIZE,
      state.sortBy,
      state.sortOrder,
      searchQuery
    );
    commit('setAttributesList', { ...results, searchQuery });
  },
  select({ commit, state }, payload) {
    const { id, isChecked } = payload;

    const attributes = state.attributes.map(attribute => ({
      ...attribute,
      detailsVisible: attribute.id === id && isChecked,
    }))

    commit('setSelected', { attributes, id, isChecked });
  },
};

const mutations = {
  setAttributesList(state, payload) {
    state.attributesList = payload.items;
    state.pageInfo = payload.pageInfo;
    ['sortBy', 'sortOrder', 'searchQuery'].forEach(key => {
      if (payload.hasOwnProperty(key)) {
        state[key] = payload[key];
      }
    });
  },
  setAttribute(state, payload){
    state.attribute = payload;
  },
  setSelected(state, payload) {
    const { attributesList, id, isChecked } = payload;

    state.attributesList = attributesList;
    state.selectedItemId = isChecked ? id : null;
  },
};

const attributesModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default attributesModule;
